var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPropsSatisfaction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86842 4.71753H16.1974C21.2333 4.71753 25.3158 8.79999 25.3158 13.8359V13.8359C25.3158 18.8719 21.2333 22.9544 16.1974 22.9544H8.76047M7.46705 22.9544H4.88023M1 22.9543H3.15568",
    stroke: "#4D523C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12097 0.80957L1.25781 4.7586L6.12097 9.14641",
    stroke: "#4D523C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4202 23.6496V14.3091L23.2229 19.5335V29.1907L11.4202 23.6496Z",
    fill: "#F9F6F3",
    stroke: "#4D523C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0185 10.2043L11.4202 14.3609L23.2473 19.4412L33.9992 14.3609L22.0185 10.2043Z",
    fill: "#F9F6F3",
    stroke: "#4D523C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5806 16.8784L27.8437 12.26",
    stroke: "#4D523C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9991 23.6496V14.3091L23.2228 19.5335V29.1907L33.9991 23.6496Z",
    fill: "#F9F6F3",
    stroke: "#4D523C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPropsSatisfaction);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzNSAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuODY4NDIgNC43MTc1M0gxNi4xOTc0QzIxLjIzMzMgNC43MTc1MyAyNS4zMTU4IDguNzk5OTkgMjUuMzE1OCAxMy44MzU5VjEzLjgzNTlDMjUuMzE1OCAxOC44NzE5IDIxLjIzMzMgMjIuOTU0NCAxNi4xOTc0IDIyLjk1NDRIOC43NjA0N003LjQ2NzA1IDIyLjk1NDRINC44ODAyM00xIDIyLjk1NDNIMy4xNTU2OCIgc3Ryb2tlPSIjNEQ1MjNDIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNNi4xMjA5NyAwLjgwOTU3TDEuMjU3ODEgNC43NTg2TDYuMTIwOTcgOS4xNDY0MSIgc3Ryb2tlPSIjNEQ1MjNDIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTEuNDIwMiAyMy42NDk2VjE0LjMwOTFMMjMuMjIyOSAxOS41MzM1VjI5LjE5MDdMMTEuNDIwMiAyMy42NDk2WiIgZmlsbD0iI0Y5RjZGMyIgc3Ryb2tlPSIjNEQ1MjNDIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMi4wMTg1IDEwLjIwNDNMMTEuNDIwMiAxNC4zNjA5TDIzLjI0NzMgMTkuNDQxMkwzMy45OTkyIDE0LjM2MDlMMjIuMDE4NSAxMC4yMDQzWiIgZmlsbD0iI0Y5RjZGMyIgc3Ryb2tlPSIjNEQ1MjNDIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy41ODA2IDE2Ljg3ODRMMjcuODQzNyAxMi4yNiIgc3Ryb2tlPSIjNEQ1MjNDIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMy45OTkxIDIzLjY0OTZWMTQuMzA5MUwyMy4yMjI4IDE5LjUzMzVWMjkuMTkwN0wzMy45OTkxIDIzLjY0OTZaIiBmaWxsPSIjRjlGNkYzIiBzdHJva2U9IiM0RDUyM0MiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";